/**
 * Texte unique d'une adresse : rue, complément, code postal, ville, pays.
 * Le champ et le pin de la carte doivent afficher exactement cette chaîne.
 */
export function formatAddressLabel(address?: EasyTech.Address): string {
  if (!address) return "";
  if (address.displayLabel) return address.displayLabel;

  const street = [address.address, address.addressCompl].filter(Boolean).join(", ");
  const locality = [address.zipCode, address.city].filter(Boolean).join(" ");
  return [street, locality, address.country].filter(Boolean).join(", ");
}
